import { Injectable } from '@angular/core';
import { PropertySetsHttpService } from '../services/http/property-sets-http.service';
import { Observable } from 'rxjs';
import { PropertySet } from '@miq/domain/property-sets';

@Injectable()
export class PropertySetService {
  constructor(private psHttpClient: PropertySetsHttpService) {}

  fetch(id: number): Observable<PropertySet> {
    return this.psHttpClient.findById(id);
  }

  create(propertySet: PropertySet): Observable<PropertySet> {
    return this.psHttpClient.create(propertySet);
  }

  update({ id, ...propertySet }: PropertySet): Observable<void> {
    return this.psHttpClient.update(id, propertySet);
  }
  delete(id: number): Observable<any> {
    return this.psHttpClient.delete(id);
  }
}
